import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoadingService } from '@app/shared/services/loading/loading.service';
import { BehaviorSubject } from 'rxjs';

@Component({
	selector: 'vass-loading',
	templateUrl: './loading.component.html',
	styleUrls: ['./loading.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf, AsyncPipe],
})
export class LoadingComponent {
	isLoading$: BehaviorSubject<boolean>;
	
	constructor(private readonly loadingService: LoadingService) {
		this.isLoading$ = this.loadingService.showLoadingSource;
	}
}
